<template>
  <div class="no-data-found">
    <img class="img-logo" src="../../assets/images/nodata/file.svg" alt="no data" />
    <div class="no-data-title">No results found.</div>
    <div class="no-data-subtitle">
      Try adjusting your search or filter <br />
      to find what you're looking for.
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoDataAspect',
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.no-data-found {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  .img-logo {
    width: 175px;
    height: auto;
    margin-bottom: 16px;
  }
  .no-data-title {
    line-height: 22px;
    font-size: 18px;
    color: #666d92;
    font-weight: 500;
    margin-bottom: 10px;
  }
  .no-data-subtitle {
    line-height: 22px;
    font-size: 14px;
    color: #666d92;
    font-weight: 500;
    text-align: center;
  }
}
</style>
